import React from "react";
import {
    Box,
    Flex,
} from "@chakra-ui/react";

import "../styles/hero.css";

import ButtonStack from "./ButtonStack";

import GridImage from "../assets/images/grid.png";
import BackgroundImage from "../assets/images/hero_cars_transparent.png";
import { FaDiscord, FaGithub } from "react-icons/fa";


const buttons = [
    { "text": "Join", "url": "https://docs.google.com/forms/d/e/1FAIpQLSfCtRkyO-QIcLIx6Uo98ecV35eRcpoECW8r1aHT9i8_CbWx0g/viewform?usp=sf_link" },
    { "text": "Discord", "icon": FaDiscord, "url": "https://discord.gg/sDYaBprFFu" },
    { "text": "GitHub", "icon": FaGithub, "url": "https://github.com/MichiganCG" }
]


export default function Hero(props) {
    const { height = "400px" } = props;

    return (
        <section id={"hero"}>
            <Box
                className={"hero"}
                height={height}
            >
                <Flex className={"container"}>
                    <Flex className={"hero-content"} zIndex={5}>
                        <h1>Michigan <span>Computer Graphics</span></h1>
                        <p>University of Michigan's Premier<br />Computer Graphics Club</p>
                        <ButtonStack items={buttons} direction={"row"} size={"lg"} gap={4} />
                    </Flex>
                    <Box
                        className={"hero-background"}
                        display={{ "base": "none", "sm": "block" }}
                    >
                        <Box className={"hero-image hero-grid"} backgroundImage={GridImage} zIndex={0} />
                        <Box className={"hero-image"} backgroundImage={BackgroundImage} zIndex={1} />
                    </Box>
                </Flex>
            </Box>
        </section>
    );
}
